const awsExports = {
  REGION: "us-east-1",
  USER_POOL_ID: "us-east-1_UQkW9XlHs",
  USER_POOL_APP_CLIENT_ID: "4piik0kahshsh0gie55n37n86n",
};

export default awsExports;
